import PolicyLayout from "layout/Policy";
import { styled } from "@mui/material/styles";
import TDpolicy from "assets/image/TD-policy-Background-03.png";
import { Divider, Grid } from "@mui/material";
import Easybot from "assets/image/Easybot.png";
import { useTranslation } from "react-i18next";

const Title = styled(`div`)`
  font-size: 3.875rem;
  line-height: 120%;
  /* or 74px */
  letter-spacing: -0.5px;
  /* Text/Primary */
  color: rgba(0, 0, 0, 0.87);
  padding-top: 224px;
  margin-bottom: 95px;
  white-space: pre-line;
  ${({ theme }) => theme.breakpoints.down("lg")} {
    padding-left: 24px;
  }
  ${({ theme }) => theme.breakpoints.down("sm")} {
    padding-top: 80px;
    padding-left: 9px;
    font-size: 2rem;
    margin-bottom: 40px;
  }
`;
const ImageBot = styled(`img`)`
  width: 100%;
  margin-top: 107px;
  background-repeat: no-repeat;
  ${({ theme }) => theme.breakpoints.down("lg")} {
    display: none;
  }
`;
const Subtitle = styled(`div`)`
  font-size: 1.125rem;
  line-height: 150%;
  /* or 27px */
  letter-spacing: 0.15px;

  /* Text/Secondary */
  color: #707070;
  white-space: pre-line;

  ${({ theme }) => theme.breakpoints.down("lg")} {
    padding-left: 24px;
  }
  ${({ theme }) => theme.breakpoints.down("md")} {
    font-size: 1rem;
  }
  ${({ theme }) => theme.breakpoints.down("sm")} {
    padding-left: 9px;
    font-size: 0.875rem;
  }
`;

const ContainerPolicy = styled(`div`)`
  padding: 95px;
  ${({ theme }) => theme.breakpoints.down("lg")} {
    padding: 24px;
  }
  ${({ theme }) => theme.breakpoints.down("sm")} {
    padding: 9px;
    margin-bottom: 40px;
  }
`;

const PolicyHeader = styled(`div`)`
  font-weight: 600;
  font-size: 1.375rem;
  line-height: 160%;
  /* or 35px */
  letter-spacing: 0.15px;

  /* Primary/Main */
  color: #1f7b44;
  white-space: pre-line;
  ${({ theme }) => theme.breakpoints.down("lg")} {
    margin-top: 56px;
  }
  ${({ theme }) => theme.breakpoints.down("md")} {
    font-size: 1rem;
  }
  ${({ theme }) => theme.breakpoints.down("sm")} {
    font-size: 0.875rem;
  }
`;

const WrapperContent = styled(`div`)`
  display: flex;
  flex-direction: row;
  margin-top: 21px;
`;
const Header = styled(`div`)`
  font-weight: 600;
  font-size: 2.25rem;
  line-height: 123.5%;
  /* or 44px */
  letter-spacing: 0.25px;

  /* Text/Primary */
  color: rgba(0, 0, 0, 0.87);
  white-space: pre-line;
  ${({ theme }) => theme.breakpoints.down("sm")} {
    font-size: 1.375rem;
  }
`;

const SubDescription = styled(`div`)`
  font-weight: 500;
  font-size: 1.125rem;
  line-height: 150%;
  /* or 27px */
  letter-spacing: 0.15px;

  /* Text/Primary */
  color: #707070;
  white-space: pre-line;
  ${({ theme }) => theme.breakpoints.down("md")} {
    font-size: 1rem;
  }
  ${({ theme }) => theme.breakpoints.down("sm")} {
    font-size: 0.875rem;
  }
`;

const Strong = styled(`a`)`
  font-size: 1rem;
  line-height: 143%;
  /* identical to box height, or 23px */
  letter-spacing: 0.15px;

  /* Primary/Light 01 */
  color: #4b9752;
  ${({ theme }) => theme.breakpoints.down("md")} {
    font-size: 1rem;
  }
  ${({ theme }) => theme.breakpoints.down("sm")} {
    font-size: 0.875rem;
  }
`;
const Bg = styled(`div`)`
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: -1;
  &:before {
    content: "";
    position: absolute;
    z-index: -1;
    background: url(${TDpolicy});
    top: 0px;
    width: 100vw;
    height: 885px;
    background-size: contain;
    background-repeat: repeat;
  }
`;
const BgMask = styled(`div`)`
  background: linear-gradient(
    11deg,
    #fafafa 60%,
    rgba(230, 230, 230, 0.630208) 119.16%,
    rgba(196, 196, 196, 0) 160.19%
  );
  width: 100vw;
  height: 886px;
`;

export default function Index() {
  const { t } = useTranslation(["policy"]);
  return (
    <PolicyLayout>
      <Bg>
        <BgMask />
      </Bg>
      <Grid container direction="row">
        <Grid item xs={12} sm={12} md={12} lg={6}>
          <Title>{t("Terms and Conditions")}</Title>
          <Subtitle>{t("condition_easyrice")}</Subtitle>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={6}>
          <ImageBot src={Easybot} alt={""} />
        </Grid>
      </Grid>
      <ContainerPolicy>
        <PolicyHeader>{t("condition_revised")}</PolicyHeader>
        {t("condition_detail", { returnObjects: true }).map((item, index) => (
          <div key={index} style={{ paddingTop: 41 }} id={item?.id}>
            <Divider />
            <WrapperContent>
              <div>
                <Header>{item?.title}</Header>
                <SubDescription style={{ marginTop: 20 }}>
                  {item?.other}
                </SubDescription>
                <Strong href="/policy">{item?.url}</Strong>
              </div>
            </WrapperContent>
          </div>
        ))}
      </ContainerPolicy>
    </PolicyLayout>
  );
}
